import { useTrans } from "@/translations";

import { WasteAmountsGraph } from "./components/graph";
import type { WasteAmountsPoint, WasteAmountsStream } from "./types";

type Props = {
  data: WasteAmountsPoint[];
  wasteStreams: WasteAmountsStream[];
  subtitle: string;
};

export const WasteAmounts: React.FC<Props> = ({
  data,
  wasteStreams,
  subtitle,
}) => {
  const { t } = useTrans();

  return (
    <div className="flex flex-col">
      <div>
        <h3 className="font-dm-sans text-[14px] font-bold">
          {t("homePage:wasteAmountTitle")}
        </h3>
        <p className="text-grey6 font-dm-sans mt-[3px] text-[12.5px]">
          {subtitle}
        </p>
      </div>

      <div className="mt-[11.55px] h-[247.5px] w-full">
        <WasteAmountsGraph data={data} wasteStreams={wasteStreams} />
      </div>

      <div className="border-grey2 mt-[11.55px] flex flex-wrap items-center gap-3 border-t pt-[11.55px]">
        {wasteStreams.map((s) => (
          <div
            key={s.key}
            className="text-grey6 flex items-center gap-[4.95px] text-[11.5px]"
          >
            <span
              className="inline-block h-[11px] w-[11px] flex-none rounded-sm border border-black/10"
              style={{ background: s.color }}
            />
            {s.name}
          </div>
        ))}
      </div>
    </div>
  );
};
